export default __webpack_public_path__ + "static/media/Descending.Active.fbceda70.svg";